// Fluxo B (?beta=true): mantém o usuário no fluxo novo ao navegar pelo site.
// Sem isso, links como o logo, "Simule seu Consórcio" do header/rodapé e os
// CTAs cadastrados no admin levam pra versão padrão da página (sem ?beta),
// e o usuário sai do fluxo que está sendo testado.
//
// Só roda quando o layout marca window.isBetaFlow (sessão is_beta, ver
// app.blade.php). Links externos, âncoras da própria página, arquivos e
// rotas do admin/API ficam como estão.

const BETA_PARAM = 'beta';
const IGNORED_PATH_PREFIXES = ['/adm', '/api', '/storage'];

function addBetaParam(anchor) {
    if (!anchor || anchor.hasAttribute('download')) return;

    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || /^(mailto|tel|javascript|whatsapp):/i.test(rawHref)) return;

    let url;
    try {
        url = new URL(rawHref, window.location.href);
    } catch (e) {
        return;
    }

    if (url.origin !== window.location.origin) return;
    if (IGNORED_PATH_PREFIXES.some(prefix => url.pathname === prefix || url.pathname.startsWith(prefix + '/'))) return;
    // Âncora pra própria página: mexer na query faria o navegador recarregar
    // em vez de só rolar até a seção.
    if (url.hash && url.pathname === window.location.pathname) return;
    if (url.searchParams.has(BETA_PARAM)) return;

    url.searchParams.set(BETA_PARAM, 'true');
    anchor.setAttribute('href', url.toString());
}

export default function betaFlowLinks() {
    if (!window.isBetaFlow) return;

    const updateAll = () => document.querySelectorAll('a[href]').forEach(addBetaParam);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateAll);
    } else {
        updateAll();
    }

    // Links criados depois do carregamento (sliders, menus dinâmicos etc.)
    // são ajustados no momento do clique, antes da navegação acontecer.
    const onActivate = (e) => {
        const anchor = e.target.closest && e.target.closest('a[href]');
        if (anchor) addBetaParam(anchor);
    };
    document.addEventListener('click', onActivate, true);
    document.addEventListener('auxclick', onActivate, true);
}
